<template>
	<div class="tw-flex tw-gap-2">
		<AppButton
			:label="$t('education.export-data')"
			startIcon="upload-02"
			secondary
			variant="gray"
			:loading="loading"
			@click="onExport"
		/>
		<AppButton
			:label="$t('hdtc.add-registration-form')"
			startIcon="plus"
			secondary
			variant="gray"
			@click="onCreate"
		/>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import { getRegistrationTableStore } from '../helper';
import { Registration } from '../../../entities/registration';
import { useAuthStore } from '@/v2/store/shared/auth-store';
import { useRegistrationDialog } from '../../../stores/registration-dialog';

const loading = ref(false);
const tableStore = getRegistrationTableStore();
const authStore = useAuthStore();
const registrationDialog = useRegistrationDialog();

const onExport = async () => {
	loading.value = true;
	try {
		const filters = tableStore.lastRequestFilters || {};
		const downloadLink = await Registration.exportData(filters, authStore.tenantId);
		window.open(downloadLink, '_blank');
	} catch (error) {
		console.error(error);
	} finally {
		loading.value = false;
	}
};

const onCreate = () => {
	registrationDialog.open();
};
</script>
